import React from "react";
import classnames from "classnames";
import { END_POINT } from "../../../constants/defaultValues";
import { Colxx } from "../../../components/common/CustomBootstrap";
import {
  Input,
  InputGroup,
  Badge,
  Row,
  Collapse,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { AddCommaNumber } from "../../../helpers/Utils";
import ProductDetail from "./ProductDetail";
import ProductImage from "../../../components/common/ProductImage";

const toPrice = (value) => {
  const parsed = parseFloat(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const getEffectiveOptionPrice = (option) => {
  const promoPrice = toPrice(option?.promo_price);
  return promoPrice > 0 ? promoPrice : toPrice(option?.value);
};

const getMenuDisplayPrice = (product) => {
  const basePrice =
    product.active_sale && toPrice(product.price_sale) > 0
      ? toPrice(product.price_sale)
      : toPrice(product.price);
  const sizePrices = Array.isArray(product.size)
    ? product.size.map(getEffectiveOptionPrice).filter((price) => price > 0)
    : [];
  const flavorPrices = Array.isArray(product.flavor)
    ? product.flavor.map(getEffectiveOptionPrice)
    : [];

  const productPrice = sizePrices.length ? Math.min(...sizePrices) : basePrice;
  const requiredFlavorPrice = flavorPrices.length
    ? Math.min(...flavorPrices)
    : 0;

  return {
    price: productPrice + requiredFlavorPrice,
    isStartingPrice:
      sizePrices.length > 1 ||
      new Set(flavorPrices.map((price) => `${price}`)).size > 1,
  };
};

const ThumbListViewMenu = ({
  product,
  order,
  sub,
  plus,
  change,
  isVerify,
  onToggleDetail,
  onAddToCartWithQuantity,
  detailDisplay,
  orderDisplay,
  // sizeSelectedId,
  // toppingSelectedId,
  // iceSelectedValue,
  // sugarSelectedValue,
  // toppingSelectedIdLen,
  // showNote,
}) => {
  // console.log('order: ', order);
  const isMobileViewport =
    typeof window !== "undefined" ? window.innerWidth < 768 : false;
  const hasOptions = Boolean(
    product.variants?.length ||
      product.ice?.length ||
      product.size?.length ||
      product.sugar?.length ||
      product.topping?.length ||
      product.flavor?.length,
  );
  const displayPrice = getMenuDisplayPrice(product);

  const handleToggleProductDetail = () =>
    onToggleDetail({
      product,
      name: "detailDisplay",
    });

  const handleCardClick = () => {
    if (product.softHide) return;

    if (hasOptions) {
      handleToggleProductDetail();
      return;
    }

    plus(product.id);
  };

  return (
    <div>
      <div
        className={classnames({
          card: detailDisplay && !isMobileViewport,
          "mb-3": detailDisplay && !isMobileViewport,
        })}
      >
        <div
          className={classnames("card d-flex flex-row mb-3", {
            disable: product.softHide ? "disable" : "",
          })}
        >
          <div
            className={
              "d-flex flex-grow-1 min-width-zero z-index-2 position-relative"
            }
            onClick={handleCardClick}
            // onClick={() =>
            //     detailDisplay
            //         ? null
            //         : onToggleDetail({
            //               product,
            //               name: 'detailDisplay',
            //           })
            // }
          >
            <div
              className="d-block position-relative cursor-pointer m-1"
              // onClick={
              //   product.softHide
              //     ? null
              //     : () => {
              //         plus(product.id);
              //       }
              // }
            >
              <ProductImage
                image={product.image}
                alt={product.name}
                fnbType={product.fnb_type}
                className="list-thumbnail responsive border-0"
                iconSize="40px"
              />
              {product.bestter ? (
                <Badge
                  className="position-absolute badge-top-right"
                  color={"success"}
                  pill
                >
                  {"Khuyên dùng"}
                </Badge>
              ) : (
                <></>
              )}
              {/* <span className='count-order'>{order?.count}</span> */}
            </div>
            <div
              className={classnames("custom-card-body", {
                "cursor-body-menu": hasOptions,
                // 'cursor-pointer':
                //     !product.ice.length &&
                //     !product.size.length &&
                //     !product.sugar.length &&
                //     !product.topping.length,
              })}
              // onClick={
              //   product.ice.length ||
              //   product.size.length ||
              //   product.sugar.length ||
              //   product.topping.length
              //     ? () =>
              //         onToggleDetail({
              //           product,
              //           name: "detailDisplay",
              //         })
              //     : null
              // }
            >
              <Row>
                <Colxx className="col-8">
                  <p
                    className={classnames(
                      "list-item-heading mb-1 d-block w-100 w-sm-100",
                      {
                        "color-primary": order?.count > 0,
                      }
                    )}
                  >
                    {order?.count > 0 ? `x${order?.count} - ` : null}
                    {product.name}
                  </p>
                </Colxx>
                {product.softHide ? (
                  <Colxx className="col-4"></Colxx>
                ) : (
                  <Colxx className="col-4">
                    <Row className="order-number-center m-end">
                      <Colxx
                        xxs="12"
                        xs="12"
                        md="12"
                        lg="12"
                        className="no-padding m-0-auto d-flex flex-column justify-content-between"
                      >
                        <div>
                          {displayPrice.isStartingPrice ? (
                            <Badge color="primary" pill>
                              Từ {AddCommaNumber(displayPrice.price)}
                            </Badge>
                          ) : product.active_sale &&
                            parseFloat(product.price_sale) > 0 &&
                            !product.size?.length &&
                            !product.flavor?.length ? (
                            <>
                              <Badge color="light" pill className="mb-1">
                                <del>{AddCommaNumber(product.price)}</del>
                              </Badge>
                              <Badge color="primary" pill className="mb-1">
                                {AddCommaNumber(product.price_sale)}
                              </Badge>
                            </>
                          ) : (
                            <Badge color="primary" pill>
                              {AddCommaNumber(displayPrice.price)}
                            </Badge>
                          )}
                          <br />
                        </div>
                      </Colxx>
                    </Row>
                  </Colxx>
                )}
                {hasOptions && detailDisplay === false ? (
                  // <span className='arrow-down-menu'>
                  //     Thêm tuỳ chọn
                  // </span>
                  <i className="iconsminds-arrow-down arrow-down-menu" />
                ) : hasOptions && detailDisplay === true ? (
                  <i className="iconsminds-arrow-up arrow-down-menu" />
                ) : null}
              </Row>
              {/* {detailDisplay ? (
                                <Row className='row-bottom'>
                                    <Colxx className='col-12'>
                                        {product.showNote ? (
                                            <InputGroup size='sm'>
                                                <NoteInput
                                                    product={product}
                                                    onToggleDetail={
                                                        onToggleDetail
                                                    }
                                                />
                                            </InputGroup>
                                        ) : (
                                            <span
                                                onClick={(e) =>
                                                    onToggleDetail({
                                                        product,
                                                        name: 'showNote',
                                                        value: true,
                                                    })
                                                }
                                                className='product-note'
                                            >
                                                Lời nhắn cho cửa hàng !
                                            </span>
                                        )}
                                    </Colxx>
                                </Row>
                            ) : null} */}
            </div>
          </div>
        </div>
        {!isMobileViewport ? (
          <Collapse isOpen={detailDisplay}>
            <Colxx
              xxs="12"
              xs="12"
              md="12"
              lg="12"
              className="d-flex flex-row"
            >
              <ProductDetail
                product={product}
                onSelected={onToggleDetail}
                onToggleDetail={onToggleDetail}
                onAddToCartWithQuantity={onAddToCartWithQuantity}
                orderDisplay={orderDisplay}
                detailDisplay={detailDisplay}
                order={order}
                sub={sub}
                plus={plus}
                change={change}
                isVerify={isVerify}
                isMobileDetail={false}
              />
            </Colxx>
          </Collapse>
        ) : null}
      </div>
      {isMobileViewport ? (
        <Modal
          isOpen={detailDisplay}
          toggle={handleToggleProductDetail}
          wrapClassName="modal-bottom-sheet"
        >
          <ModalHeader
            toggle={handleToggleProductDetail}
            className="border-bottom-0 pb-0 w-100"
          >
            <div className="d-flex flex-wrap align-items-center">
              <span className="mr-2">{product.name}</span>
              {(product.active_sale && parseFloat(product.price_sale) > 0 ? parseFloat(product.price_sale) : parseFloat(product.price)) > 0 && (
                <span style={{ fontSize: "14px", fontWeight: "normal", color: "#555" }}>
                  - {AddCommaNumber(product.active_sale && parseFloat(product.price_sale) > 0 ? parseFloat(product.price_sale) : parseFloat(product.price))} đ
                  {(() => {
                    return false; // Wholesale pricing is POS-only
                  })() && (
                    <span className="badge badge-secondary ml-2" style={{ backgroundColor: "#6c757d", color: "#fff", padding: "4px 8px", borderRadius: "4px" }}>
                      Sỉ: {AddCommaNumber(product.price_wholesale)} đ
                    </span>
                  )}
                </span>
              )}
            </div>
          </ModalHeader>
          <ModalBody style={{ overflowY: "auto", maxHeight: "calc(85vh - 70px)" }}>
            <ProductDetail
              product={product}
              onSelected={onToggleDetail}
              onToggleDetail={onToggleDetail}
              onAddToCartWithQuantity={onAddToCartWithQuantity}
              orderDisplay={orderDisplay}
              detailDisplay={detailDisplay}
              order={order}
              sub={sub}
              plus={plus}
              change={change}
              isVerify={isVerify}
              isMobileDetail={true}
              onCloseDetail={handleToggleProductDetail}
            />
          </ModalBody>
        </Modal>
      ) : null}
    </div>
  );
};

export default React.memo(ThumbListViewMenu);

class NoteInput extends React.Component {
  constructor(props) {
    super(props);

    this.textInput = React.createRef();
    this.focus = this.focus.bind(this);
  }

  focus() {
    // Explicitly focus the text input using the raw DOM API
    // Note: we're accessing "current" to get the DOM node
    this.textInput.current.focus();
  }

  componentDidUpdate() {
    if (this.textInput && this.textInput.current) {
      this.focus();
    }
  }

  render() {
    const { product, onToggleDetail } = this.props;

    return (
      <Input
        ref={this.textInput}
        autoFocus={true}
        onChange={(e) =>
          onToggleDetail({
            product,
            name: "note",
            value: e.target.value,
          })
        }
        className="custom-input-underline"
        placeholder="Ghi chú"
      />
    );
  }
}
